// Shared formatting helpers for the service detail panels.

export function relativeTime(unix?: number): string {
    if (!unix) return "—";
    const secs = Math.max(0, Math.floor(Date.now() / 1000) - unix);
    if (secs < 60) return `${secs}s ago`;
    if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
    if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
    return `${Math.floor(secs / 86400)}d ago`;
}

export function uptime(startedAt?: number): string {
    if (!startedAt) return "—";
    let secs = Math.max(0, Math.floor(Date.now() / 1000) - startedAt);
    const d = Math.floor(secs / 86400);
    secs -= d * 86400;
    const h = Math.floor(secs / 3600);
    secs -= h * 3600;
    const m = Math.floor(secs / 60);
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
}

export function ms(v?: number): string {
    return v === undefined ? "—" : `${v.toFixed(2)} ms`;
}

// relativeTimeMs is relativeTime for epoch-millisecond values, which is how
// the search index registry records timestamps.
export function relativeTimeMs(millis?: number): string {
    if (!millis) return "—";
    return relativeTime(Math.floor(millis / 1000));
}

// bytes renders a byte count compactly, so index sizes read at a glance.
export function bytes(n?: number): string {
    if (n === undefined || n <= 0) return "—";
    const units = ["B", "KB", "MB", "GB", "TB", "PB"];
    let value = n;
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
        value /= 1024;
        unit++;
    }
    return unit === 0 ? `${value} ${units[unit]}` : `${value.toFixed(1)} ${units[unit]}`;
}

// count renders a document count with thousands separators.
export function count(n?: number): string {
    if (n === undefined) return "—";
    return n.toLocaleString("en-US");
}
